import { useQuery } from '@tanstack/react-query';
import { devtoolsService } from '../services/devtoolsService';
import type { LogSearchFilters } from '../types/devtools.types';

export function useCompanyAccess() {
  return useQuery({
    queryKey: ['devtools', 'company-access'],
    queryFn: () => devtoolsService.getCompanyAccess(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useRequestLogs(filters: LogSearchFilters) {
  return useQuery({
    queryKey: ['devtools', 'logs', filters],
    queryFn: () => devtoolsService.searchLogs(filters),
    placeholderData: (previous) => previous,
  });
}
